import React from "react";
import "./PrivacyPolicy.css";

const TermsConditions = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Terms & Conditions</h1>
        <p className="effective-date">Effective Date: May 07, 2026</p>

        <p>
          By using our website, you agree to the following terms and
          conditions.
        </p>

        <section>
          <h2>Products</h2>

          <p>
            We try to display product colors, images, and details as accurately
            as possible. However, slight variations may occur due to screen
            settings and photography.
          </p>
        </section>

        <section>
          <h2>Pricing</h2>

          <p>
            All prices are listed in INR and are subject to change without
            prior notice.
          </p>
        </section>

        <section>
          <h2>Orders</h2>

          <p>We reserve the right to:</p>

          <ul>
            <li>Cancel suspicious orders</li>
            <li>Refuse service</li>
            <li>Limit product quantities</li>
          </ul>
        </section>

        <section>
          <h2>User Responsibilities</h2>

          <p>
            Customers must provide accurate information including:
          </p>

          <ul>
            <li>Shipping address</li>
            <li>Contact details</li>
            <li>Payment information</li>
          </ul>
        </section>

        <section>
          <h2>Intellectual Property</h2>

          <p>
            All website content including logos, images, text, graphics, and
            designs belong to <span>SaPra</span>.
          </p>

          <p>Unauthorized use is strictly prohibited.</p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>

          <p>
            We are not responsible for delays or issues caused by:
          </p>

          <ul>
            <li>Courier services</li>
            <li>Natural events</li>
            <li>Technical issues beyond our control</li>
          </ul>
        </section>

        {/* <section>
          <h2>Contact Us</h2>

          <p>
            For any questions regarding these Terms & Conditions,
            contact us:
          </p>

          <div className="contact-box">
            <p>Email: support@sapra.com</p>
            <p>Phone: +91 9876543210</p>
          </div>
        </section> */}
      </div>
    </div>
  );
};

export default TermsConditions;